


















































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { insertFromPosition } from '@/main/utils/stringHelper';

// eslint-disable-next-line no-unused-vars
import { store, SSmsDynText } from './store/edit';
import { NAME } from './constants';


export default editFactory(NAME, store).extend({
	data() {
		return {
			TextCaretPosition: 0,
		};
	},
	computed: {
		localizeCharCount() {
			return this.LocalizePopisostatni('CharCount');
		},
		TextLength() {
			return this.Text ? this.Text.length : 0;
		},
		SmsDynTextListCmp() {
			const SmsDynTextListFiltered = this.SSmsDynTextList?.filter((item) => item.SmsTypPzn === this.SmsTypPzn) || [];
			return _.map(SmsDynTextListFiltered, (item) => ({ Text: item.Text, Value: item.ZaznamId }));
		},
		SmsDynTextItem() : SSmsDynText | null {
			if (this.SmsDynText) {
				return this.SSmsDynTextList?.find((item) => item.ZaznamId === this.SmsDynText) || null;
			}
			return null;
		},
	},
	watch: {
		SmsTypPzn() {
			this.SmsDynText = null;
		},
	},
	methods: {
		setDefault() {
			const defaultTemplate = this.SmsTextRefList?.find((item) => item.SmsTypPzn === this.SmsTypPzn);
			this.PozdravText = defaultTemplate?.PozdravText || null;
			this.Text = defaultTemplate?.Text || null;
		},
		addToText() {
			const dynZnac = this.SmsDynTextItem?.DynZnac || '';
			this.Text = insertFromPosition(this.Text, dynZnac, this.TextCaretPosition);
		},
		updateTextCaretPosition(event: UIEvent) {
			this.TextCaretPosition = (event?.target as HTMLInputElement)?.selectionStart || 0;
		},
	},
});
